import script from "./AddressDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./AddressDrawer.vue?vue&type=style&index=0&id=2754bb30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2754bb30"]])

export default __exports__